import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { API } from '../context/AuthContext';

const SendDigestButton = () => {
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    setSending(true);
    try {
      const res = await axios.post(`${API}/digest/send`);
      toast.success(res.data.message || 'Digest enviado');
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'No se pudo enviar el digest');
    } finally {
      setSending(false);
    }
  };

  return (
    <Button
      onClick={handleSend}
      disabled={sending}
      variant="outline"
      data-testid="send-digest-button"
      className="gap-2 rounded-full border-slate-200 hover:border-indigo-300 hover:bg-indigo-50 text-slate-600 hover:text-indigo-700 transition-colors shrink-0"
    >
      {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}
      {sending ? 'Enviando...' : 'Enviar digest semanal'}
    </Button>
  );
};

export default SendDigestButton;
